import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface DashboardActivityItemProps {
  children: ReactNode;
  title: string;
  to: string;
  trailing?: ReactNode;
}

export default function DashboardActivityItem({
  children,
  title,
  to,
  trailing,
}: DashboardActivityItemProps) {
  return (
    <Link
      to={to}
      className="flex w-full flex-col gap-2 rounded-lg bg-secondary-50 p-3 text-left transition-colors hover:bg-secondary-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 sm:flex-row sm:items-center sm:justify-between"
    >
      <div className="min-w-0 flex-1">
        <h3 className="truncate text-sm font-medium text-secondary-900">
          {title}
        </h3>
        <div className="mt-1 space-y-1 text-xs text-secondary-500">
          {children}
        </div>
      </div>
      {trailing && (
        <div className="flex-shrink-0 self-end text-xs text-secondary-500 sm:self-center sm:text-right">
          {trailing}
        </div>
      )}
    </Link>
  );
}
